<template>
  <v-container class="pa-0">
    <div class="pb-3 font-weight-medium">
      Set Price
    </div>

    <prices
      :subscription="subscription"
      :currency-icon="item.currency_icon"
      v-on="$listeners"
    />

    <v-divider class="my-6" />
    
    <intervals
      v-if="!brain.express"
      :subscription="subscription"
      v-on="$listeners"
    />

    <next
      :disabled="!(brain.amount > 0)"
      v-on="$listeners"
    />
  </v-container>
</template>

<script>
import Prices from './Prices.vue'
import Intervals from './Intervals.vue'
import Next from '../Next.vue'

export default {
  name: 'StepSubscription',
  components: { Prices, Intervals, Next },
  props: {
    item: {
      type: Object,
      default: ()=>{return {}}
    },
    brain: {
      type: Object,
      default: ()=>{return {}}
    },
  },
  computed: {
    subscription(){return this.item.subscription || {}},
  }
}
</script>